module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Heidi McLaughlin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Heidi McLaughlin")]), _vm._v(" is a "), _c('I', [_vm._v("New York Times")]), _vm._v(" and "), _c('I', [_vm._v("USA Today")]), _vm._v(" bestselling author. Originally from the Pacific Northwest, she now lives in picturesque Vermont with her husband and two daughters. Also renting space in their home is an over-hyper beagle/Jack Russell, Buttercup, a Highland West/mini schnauzer, Jill, and her brother, Racicot. When she's isn't writing stories, you'll find her sitting court-side at her daughters' basketball games. "), _c('br'), _c('br')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NGtX5G/images/9781455598304_cover_epub.jpg?1733151275842",
      "alt": "This image is the cover for the book Grand Slam, The Boys of Summer"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Grand Slam, The Boys of Summer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("New York Times")]), _vm._v(" bestselling author of "), _c('i', [_vm._v("Forever My Girl")]), _vm._v("."), _c('br'), _c('br'), _vm._v(" WIN THE GAME. LOSE YOUR HEART. "), _c('br'), _c('br'), _vm._v(" Everyone knows who I am and that I could have any female fan I want. That's supposed to be the \"perk\" of playing left field for the Boston Renegades. But I don't want just any woman; I want "), _c('i', [_vm._v("her")]), _vm._v("."), _c('br'), _c('br'), _vm._v(" She should be just another face in the crowd, but I can't stop thinking about the one night we spent together-and her look of regret the morning after."), _c('br'), _c('br'), _vm._v(" Because Saylor Blackwell is the kind of woman who haunts a man. Smart, sexy as hell, and one of the best managers in the business. She's every ballplayer's dream woman. And I'd do anything to make things right with her."), _c('br'), _c('br'), _vm._v(" I'm done sitting on the bench when it comes to Saylor Blackwell. Time to swing for the fences.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grand Central Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0